import { shareReplay } from "./operators.js";
/**
 * shareReplay + refCount
 */
export function shareReplayRC(bufferSize) {
    return shareReplay({ bufferSize, refCount: true });
}
//# sourceMappingURL=share-replay-rc.js.map